import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskCreateProjectRoute: InvariantJiraRoute = {
	name: 'servicedesk-create-project',
	path: '/jira/servicedesk/create-project',
	exact: true,
};
